<div *ngIf="editandoTitulo; else readonly">
  <div [style.backgroundColor]="corTitulo" class="editor-wrapper">
    <div class="editor-container">
      <mat-icon
        appBackgroundContrast
        [backgroundColor]="corTitulo"
        class="material-icons-outlined icon-titulo"
        >title</mat-icon
      >

      <div
        #editor
        class="editor editor-titulo"
        [ngClass]="{ novo: novoTitulo }"
        [style.height.px]="titulo.alturaExibicao"
        placeholder="Insira o titulo"
        contenteditable="true"
        [innerHTML]="titulo.texto"
        (keyup)="keyPressed($event)"
        (keyup.enter)="enterPressed($event)"
        (keyup.esc)="escPressed()"
        (paste)="onPaste($event)"
        (blur)="onBlur()"
      ></div>
    </div>
    <div class="editor-titulo-icon">
      <div
        class="char-count"
        appBackgroundContrast
        [backgroundColor]="corTitulo"
      >
        {{
          !editorElement || !editorElement.innerHTML
            ? 0
            : editorElement?.innerText?.length
        }}/{{ limiteCaracteresTitulo }}
      </div>
      <mat-icon
        appBackgroundContrast
        [backgroundColor]="corTitulo"
        class="material-icons-outlined editor-titulo-icons-info"
        matTooltip="Adicione textos em negrito pressionando as teclas Ctrl + B.
           Adicione textos em itálico pressionando as teclas Ctrl + I.
           Adicione textos com sublinhado pressionando as teclas Ctrl + U."
        [matTooltipClass]="'editor-comentario-mattooltip'"
        [matTooltipPosition]="'below'"
        style="padding-left: 8px; cursor: pointer; font-size: 10pt"
        >info</mat-icon
      >
    </div>
  </div>
</div>

<ng-template #readonly>
  <table
    appBackgroundContrast
    [backgroundColor]="corTitulo"
    class="readonly-wrapper"
    (click)="mouseupEdicao()"
  >
    <tr>
      <td>
        <span
          class="texto"
          [class.texto-titulo]="titulo.mnemonico"
          #viewer
          [innerHTML]="titulo.texto"
          >{{ titulo.texto }}</span
        >
      </td>
      <td>
        <mat-icon
          class="btn-excluir"
          [ngStyle]="{ color: editandoTitulo ? 'color' : 'unset' }"
          svgIcon="close"
          matTooltip="Excluir"
          (click)="confirmarDelecaoComentario($event, titulo)"
        >
        </mat-icon>
      </td>
    </tr>
  </table>
</ng-template>
